const func = require('../_util.js')
const page = 1
const pageSize = 10

const data = (() => {
  const result = []
  for (let index = 0; index < 60; index++) {
    result.push({
      id: 1,
      'goodsId|1000022000-9999229999': 1234882256,
      'goodsImg|1': [
        'https://img14.360buyimg.com/n0/jfs/t1/158179/4/13755/256320/604f6889Eaf3d932e/4a3cd5c31a2fefa2.jpg',
        'https://img14.360buyimg.com/n0/jfs/t1/159908/21/13386/204503/604f3b53E2190173c/e930b112ce905538.jpg'
      ],
      'goodsPic|1': [
        'https://img14.360buyimg.com/n0/jfs/t1/158179/4/13755/256320/604f6889Eaf3d932e/4a3cd5c31a2fefa2.jpg',
        'https://img14.360buyimg.com/n0/jfs/t1/159908/21/13386/204503/604f3b53E2190173c/e930b112ce905538.jpg'
      ],
      'goodsName|1': ['@ctitle(20)', '@ctitle(50)'],
      goodsCate: '@cword()',
      'goodsSku|1-2': [
        {
          'id|1': [1, 2],
          stock: 111,
          color: '黑色'
        }
      ],
      'goodsNo|100000-999999': 123456,
      goodsSupplier: '@cword()',
      'originPrice|100-1000.2': 123.33,
      'price|1-100.2': 123.33,
      'salePrice|1-100.2': 123.33,
      'sale|100-9999': 1236,
      'stock|100-9999': 10000,
      updateTime: '@datetime',
      'status|1': [1, 2]
    })
  }
  return result
})()

const list = {
  url: '/team/list',
  type: 'post',
  response: func.resultPageSuccess(page, pageSize, data)
}

const info = {
  url: '/team/info',
  type: 'post',
  response: func.resultSuccess(data.find(item => item.id === 1))
}

module.exports = [list, info]
